import Button from "../../../../../ui/button";
import { useDataEstimateContext } from "../../../hooks/useModalContex";
import ModalRansom from "../../modals/modalRansom";
import style from "../styles.module.scss";
import ModalRedirectToPageWizardTradeIn from "../../modals/modalRedirectToPageWizardTradeIn";
import useOpenModal from "../../../../../ui/modal/hooks/useOpenModal";

interface ISellEstimateProps {
  isSecondary: boolean;
}

const SellEstimate = ({ isSecondary }: ISellEstimateProps) => {
  const { dataModal } = useDataEstimateContext();

  const {
    open: openRansom,
    offsetY: offsetYRansom,
    handleChangeModal: handleChangeModalRansom,
  } = useOpenModal();

  const {
    open: openSell,
    offsetY: offsetYSell,
    handleChangeModal: handleChangeModalSell,
  } = useOpenModal();

  const {
    open: openTradeIn,
    offsetY: offsetYTradeIn,
    handleChangeModal: handleChangeModalTradeIn,
  } = useOpenModal();

  return (
    <div className={style.sell}>
      <div className={style.sell__container}>
        <div className={style.sell__offer}>
          <div className={style.sell__text}>
            <p style={{ textAlign: "center" }}>
              Купим вашу квартиру быстро и без сложностей. Оставьте заявку —
              узнайте сумму
            </p>
          </div>

          <div className={style.sell__buttons}>
            <Button
              label="Выкуп"
              onClick={(event) => handleChangeModalRansom(true)}
            />
            <Button
              label="Продать в ТРЕЙД-ИН"
              onClick={(event) => handleChangeModalTradeIn(true)}
              variant="dark"
            />
          </div>
        </div>

        <ModalRedirectToPageWizardTradeIn
          isOpen={openTradeIn}
          onDismiss={(value) => handleChangeModalTradeIn(value)}
          offsetY={offsetYTradeIn}
        />

        {dataModal && (
          <ModalRansom
            isOpen={openRansom}
            onDismiss={(value) => handleChangeModalRansom(value)}
            data={dataModal}
            offsetY={offsetYRansom}
          />
        )}
      </div>
    </div>
  );
};

export default SellEstimate;
